module.exports = __webpack_public_path__ + "img/lock.ca657a67.svg";